// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"81b712f9","331":"dc91998a","386":"06ef4781","389":"5ddb9ec4","481":"c58202ad","589":"963a8bee","985":"be07a3f4"}[chunkId] + ".chunk.js";
};